import PQueue from 'p-queue';

export type QueueTask = () => Promise<void>;

const queue = new PQueue({ concurrency: 1 });

export const enqueue = (fn: QueueTask) => {
  queue.add(fn).catch((error) => {
    console.error('Error processing queue task:', error);
  });
};
